import React, { Component, Fragment } from 'react';
import isWindow from 'components/common/helpers/isWindow';
import SecureLoadingContent from 'components/components/common/SecureLoadingContent';
import { connect } from 'react-redux';
import {
  setMyTrips,
  setFilterDateInTrips
} from 'components/actions/serviceActions';
import AllReservations from './MyTrips/AllReservations';

class MyTrips extends Component {

  componentDidMount() {
    this.props.setFilterDateInTrips(null);
  }

  callbackDataLoaded = (data) => {
    this.props.setMyTrips(data);
  }

  render() {
    if (!isWindow) return null;
    return (
      <SecureLoadingContent
        path="/pwa/dashboard/all-reservations"
        method="get"
        params={{ date: this.props.myTripsDate }}
        callback={this.callbackDataLoaded}
      >
        <AllReservations />
      </SecureLoadingContent>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    myTripsDate: state.service.myTripsDate,
  }
}

export default connect(
  mapStateToProps,
  { setMyTrips, setFilterDateInTrips }
)(MyTrips);
